<template>
  <div class="page">
    <div class="oitem" v-for="(item,index) in orderList" :key="index" @click="showModal(item)">
      <div class="oparam big">订&ensp;单&ensp;号：{{item.orderNo}}</div>
      <div class="oparam big">发货单位：{{item.unitFrom}}</div>
      <div class="oparam big">收货单位：{{item.unitTo}}</div>
      <div class="oparam big">出厂时间：{{item.time}}</div>
      <div class="oparam">货&emsp;&emsp;物：{{item.materiel}}</div>
      <div class="oparam">预约重量：{{item.mnum}}</div>
      <div class="oparam">车&emsp;&emsp;号：{{item.vehicle}}</div>
      <div class="oparam">提货重量：{{item.net}}</div>
    </div>

    <a-modal
      title="签收"
      style="top: 20px;"
      :width="400"
      v-model="showMdl"
      @ok="handleOk"
      :confirmLoading="confirmLoading"
    >
      <a-form :form="form">
        <a-form-item
          label="时间"
          :label-col=" { span: 6 }"
          :wrapper-col=" { span: 12 }"
        >{{qdate | formatDate}}</a-form-item>

        <a-form-item label="收货重量" :label-col=" { span: 6 }" :wrapper-col=" { span: 12 }">
          <a-input-number :min="0" :max="2000"></a-input-number>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import Moment from 'moment'

export default {
  data() {
    return {
      orderList: [
        {
          orderNo: '0200325168562',
          unitFrom: '恒赛特自动化科技有限公司',
          unitTo: '蚂蚁金服科技',
          materiel: '无烟煤',
          mnum: 30,
          vehicle: '苏E1168',
          net: 30,
          time: '2020-05-28 14:05:18'
        },
        {
          orderNo: '0200325168563',
          unitFrom: '恒赛特自动化科技有限公司',
          unitTo: '阿里巴巴集团',
          materiel: '稀土',
          mnum: 60,
          vehicle: '苏E1168',
          net: 58,
          time: '2020-05-28 14:05:28'
        },
        {
          orderNo: '0200325168564',
          unitFrom: '恒赛特自动化科技有限公司',
          unitTo: '菜鸟网络',
          materiel: '乙二醇冷却液',
          mnum: 90,
          vehicle: '苏E1168',
          net: 82,
          time: '2020-05-28 14:05:21'
        },
        {
          orderNo: '0200325168565',
          unitFrom: '恒赛特自动化科技有限公司',
          unitTo: '华为技术有限公司',
          materiel: '单晶硅',
          mnum: 70,
          vehicle: '苏E1168',
          net: 71,
          time: '2020-05-28 14:05:22'
        }
      ],
      showMdl: false,
      qdate: new Date(),
      confirmLoading: false,
      form: this.$form.createForm(this)
    }
  },
  created() {},
  filters: {
    formatDate(value) {
      return Moment(value).format('YYYY-MM-DD HH:mm:ss')
    }
  },
  methods: {
    showModal(record) {
      this.showMdl = true
      this.qdate = new Date()
    },
    handleOk() {
      this.showMdl = false
    }
  }
}
</script>

<style>
.oitem {
  border: 1px solid #aaa;
  margin: 10px;
  display: flex;
  flex-flow: row wrap;
}
.oitem:hover {
  background-color: #ccc;
}
.oparam {
  border: 0.1px solid #eee;
  width: 50%;
  padding-left: 5px;
}
.big {
  width: 100%;
}
</style>